export var layoutDefaultFeaturesToDisabled = [
  'use_localstorage_for_settings',
  'header_saveload',
  // 'header_compare',
  // 'study_templates',
  'symbol_search_hot_key',
  // 'show_interval_dialog_on_key_press', //TODO: Verificar na doc do trading view
  'timeframes_toolbar', //TODO: Verificar na doc do trading view
  // 'header_settings',
  // 'header_indicators'
  'header_compare',
  'study_templates',
  'show_interval_dialog_on_key_press',
];

export var layoutBasicFeaturesToDisabled = [
  ...layoutDefaultFeaturesToDisabled,
  'use_localstorage_for_settings',
  'items_favoriting',
  'save_chart_properties_to_local_storage',
  'create_volume_indicator_by_default',
  'create_volume_indicator_by_default_once',
  'volume_force_overlay',
  'right_bar_stays_on_scroll',
  'constraint_dialogs_movement',
  'charting_library_debug_mode',
  'side_toolbar_in_fullscreen_mode',
  'header_in_fullscreen_mode',
  'disable_resolution_rebuild',
  'chart_scroll',
  'chart_zoom',
  'horz_touch_drag_scroll',
  'vert_touch_drag_scroll',
  'mouse_wheel_scroll',
  'pressed_mouse_move_scroll',
  'mouse_wheel_scale',
  'pinch_scale',
  'axis_pressed_mouse_move_scale',
  'low_density_bars',
  'uppercase_instrument_names',
  'no_min_chart_width',
  'fix_left_edge',
  'lock_visible_time_range_on_resize',
  'shift_visible_range_on_new_bar',
  'custom_resolutions',
  'end_of_period_timescale_marks',
  'cropped_tick_marks',
  'study_overlay_compare_legend_option',
  'study_symbol_ticker_description',
  'auto_enable_symbol_labels',
  'insert_indicator_dialog_shortcut',
  'two_character_bar_marks_labels',
  'confirm_overwrite_if_chart_layout_with_name_exists',
  'determine_first_data_request_size_using_visible_range',
  'move_logo_to_main_pane',
  'datasource_copypaste',
  'seconds_resolution',
  'tick_resolution',
  'secondary_series_extend_time_scale',
  'header_widget',
  'header_symbol_search',
  'symbol_search_hot_key',
  'header_resolutions',
  'show_interval_dialog_on_key_press',
  'header_chart_type',
  'header_compare',
  'header_undo_redo',
  'header_screenshot',
  'header_fullscreen_button',
  'border_around_the_chart',
  'header_saveload',
  'left_toolbar',
  'control_bar',
  'legend_widget',
  'display_legend_on_all_charts',
  'object_tree_legend_mode',
  'edit_buttons_in_legend',
  'show_hide_button_in_legend',
  'format_button_in_legend',
  'delete_button_in_legend',
  'context_menus',
  'pane_context_menu',
  'scales_context_menu',
  'legend_context_menu',
  'main_series_scale_menu',
  'display_market_status',
  'remove_library_container_border',
  'property_pages',
  'show_chart_property_page',
  'chart_property_page_scales',
  'chart_property_page_trading',
  'chart_property_page_right_margin_editor',
  'countdown',
  'dont_show_boolean_study_arguments',
  'hide_last_na_study_output',
  'symbol_info',
  'timezone_menu',
  'snapshot_trading_drawings',
  'source_selection_markers',
  'go_to_date',
  'adaptive_logo',
  'show_dom_first_time',
  'hide_left_toolbar_by_default',
  'chart_style_hilo',
  'chart_style_hilo_last_price',
  'pricescale_currency',
  'pricescale_unit',
  'scales_date_format',
  'popup_hints',
  'save_shortcut',
  'show_right_widgets_panel_by_default',
  'show_object_tree',
  'show_spread_operators',
  'hide_exponentiation_spread_operator',
  'hide_reciprocal_spread_operator',
  'compare_symbol_search_spread_operators',
  'studies_symbol_search_spread_operators',
  'hide_resolution_in_legend',
  'hide_unresolved_symbols_in_legend',
  'show_zoom_and_move_buttons_on_touch',
  'hide_main_series_symbol_from_indicator_legend',
  'hide_price_scale_global_last_bar_value',
  'show_average_close_price_line_and_label',
  'hide_image_invalid_symbol',
  'hide_object_tree_and_price_scale_exchange_label',
  'scales_time_hours_format',
  'use_na_string_for_not_available_values',
  'pre_post_market_sessions',
  'show_percent_option_for_right_margin',
  'lock_visible_time_range_when_adjusting_percentage_right_margin',
  'iframe_loading_compatibility_mode',
  'use_last_visible_bar_value_in_legend',
  'symbol_info_long_description',
  'symbol_info_price_source',
  'chart_template_storage',
  'request_only_visible_range_on_reset',
  'clear_price_scale_on_error_or_empty_bars',
  'show_symbol_logos',
  'show_exchange_logos',
  'show_symbol_logo_in_legend',
  'show_symbol_logo_for_compare_studies',
  'always_show_legend_values_on_mobile',
  'studies_extend_time_scale',
  'accessibility',
];


export var layoutAdvancedFeaturesToDisabled = [...layoutDefaultFeaturesToDisabled]
export var layoutMobileFeaturesToDisabled = [
  ...layoutDefaultFeaturesToDisabled,
  'header_symbol_search'
]
